import environments from './XEnvironment.js';
import { XTemplateDOM } from './XDOM.js';
import { xArray, xInteger, xObject, xString } from './XTypes.js';
import { xBase64ToObject, xObjectToBase64 } from './XUtil.js';

import template from './XTextVoice.html?raw';

export class XTextVoice
{
    static get type () { return 'XTextVoice'; }

    static #extensionPriority = ['mp3', 'ogg'];

    static detectAvailableExtensions()
    {
        console.log('TODO');
    }

    #dom;
    #parent;
    #content;

    #elementText;

    #audioURL = '';
    #audio = null;
    #audioPromise = null;

    constructor(dom, parent, content)
    {
        this.#dom         = dom;
        this.#parent      = parent;
        this.#content     = content;
        this.#elementText = this.#dom.text._element;

        if(this.#elementText.dataset.xData)
        {
            this.update(xBase64ToObject(this.#elementText.dataset.xData));
        }
        this.#dom.play?._element.addEventListener('click', () =>
        {
            console.log('PLAY', this.#audioURL);
            this.play();
        });

        const elementsTextHighlight = this.#elementText.querySelectorAll('.x-text-highlight');
        const xAddIcon = (element, className) => 
        {
            const elementIcon = document.createElement('i');
            elementIcon.classList.add('me-1', 'bi', className);
            element.prepend(elementIcon);
        }
        for(const elementTextHighlight of elementsTextHighlight)
        {
            if(elementTextHighlight.classList.contains('x-keyboard-shift'))
            {
                xAddIcon(elementTextHighlight, 'bi-shift');
            }
            else if(elementTextHighlight.classList.contains('x-keyboard-enter'))
            {
                xAddIcon(elementTextHighlight, 'bi-arrow-return-left');
            }
        }
    };

    get isPlaying()
    {
        return this.#audio ? this.#audio.paused : false;
    }

    set volume(volume)
    {
        if(!this.#audio)
        {
            return;
        }
        this.#audio.volume = volume;
    }

    async play()
    {
        if(!this.#audioURL)
        {
            return;
        }
        if(this.#audioPromise)
        {
            return this.#audioPromise;
        }
        const audio = new Audio(this.#audioURL);
        this.#audio = audio;
        this.#audioPromise = new Promise((resolve, reject) => {
            audio.addEventListener('pause', () => {
                if(audio == this.#audio)
                {
                    this.#audio = null;
                    this.#audioPromise = null;
                }
                resolve(audio.ended);
            });
            audio.addEventListener('error', () => {
                resolve(false);
            });
            audio.addEventListener('abort', () => {
                resolve(false);
            });
            audio.volume = this.#content.masterVolume;
            audio.play().catch(reject);
        });
        return this.#audioPromise;
    }

    stop()
    {
        this.#audio?.pause();
        this.#audio = null;
        this.#audioPromise = null;
    }

    update(data)
    {
        this.stop();
        this.#audioURL = environments.active.urlAssets + data.$key + '/' + data.$version + '/' + data.name;
        
        if(this.#audioURL)
        {
            let extension = null;
            for(const extensionPriority of XTextVoice.#extensionPriority)
            {
                if(data.extensions?.includes(extensionPriority))
                {
                    extension = extensionPriority;
                    break;
                }
            }
            this.#audioURL = extension ? (this.#audioURL + '.' + extension) : '';
        }
    }

    get _dom        () { return this.#dom;         }
    get parent      () { return this.#parent;      }
    get elementText () { return this.#elementText; }
};

export class XTextVoiceReactive extends XTextVoice
{
    static get specification () 
    {
        return xObject({
            $: XTextVoice.type,
            text: xString('', {
                localized: true
            }),
            extensions: xArray(xString()),
            name: xString(),
            duration: xInteger(),
            autoTranslate: xString(),
        });
    }
    
    static get template () { return XTextVoiceReactive.#template; }

    static #template;

    static initDOM(domEnvironment)
    {
        this.#template = new XTemplateDOM(template, XTextVoiceReactive.specification, domEnvironment);
    }

    #data;
    #usedTemplate;

    constructor(data, parent, content, {
        basePath = environments.active.urlAssets_, 
        template = XTextVoiceReactive.template
    } = {})
    {
        super(template._createAccessibleDOM(data, {
            bindElementsToData: true
        }), parent, content);
        this.#data = data;
        this.#usedTemplate = template;
        data._enableParenting();
        this._dom._computed((data) =>
        {
            this.update({
                $key: data._key,
                $version: data._version,
                name: data.name,
                extensions: data.extensions.toJSON()
            });
        }, data, basePath);
        //this.#dom._addAttachment(this.#static);
    };

    _render()
    {
        //delete dom._element.removeAttribute('contenteditable');
        const dom = this.#usedTemplate._createAccessibleDOM(this.#data);
        dom._element.dataset.xData = xObjectToBase64({
            $key: this.data._key,
            $version: this.data._version,
            name: this.data.name,
            extensions: this.data.extensions.toJSON()
        });
        return dom;
    }

    get data () { return this.#data; }
};
